export default __webpack_public_path__ + "static/media/reenroll-hra-checklist.4a42a9ca.svg";